import React, { useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, CheckCircle2, ArrowRight, ShieldCheck } from 'lucide-react';
import { PRODUCTS } from '../data/products';
import { useCartStore } from '../store/useCartStore';
export function ProductPage() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const product = PRODUCTS.find(p => p.id === Number(id));
  const {
    addItem
  } = useCartStore();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);
  if (!product) {
    return <div className="min-h-screen flex items-center justify-center bg-brand-bg" data-id="element-236" data-mp="ew5f0658os7k">
        <div className="text-center" data-id="element-237" data-mp="9xaoei115zcw">
          <h1 className="text-3xl font-serif font-medium text-brand-primary mb-4" data-id="element-238" data-mp="9w9ckbc6x8u4">
            Товар не знайдено
          </h1>
          <button onClick={() => navigate('/')} className="text-brand-accent font-medium hover:underline" data-id="element-239" data-mp="1q9prtxu03vzn">
            Повернутися на головну
          </button>
        </div>
      </div>;
  }
  return <div className="min-h-screen bg-brand-bg text-brand-text selection:bg-brand-accent/20 selection:text-brand-primary font-sans pt-24" data-id="element-240" data-mp="1gph2owyzhoqo">
      <main className="max-w-7xl mx-auto px-6 lg:px-8 py-12 lg:py-24" data-id="element-241" data-mp="1lq54mdor3pzo">
        <Link to="/" className="inline-flex items-center gap-2 text-brand-muted hover:text-brand-primary font-medium mb-12 transition-colors text-sm tracking-wide uppercase" data-id="element-242" data-mp="1qogdal3b7ugb">
          <ArrowLeft className="w-4 h-4" data-id="element-243" data-mp="xyhkqfpwpf6w" />
          Назад до колекції
        </Link>

        <div className="bg-brand-surfaceAlt rounded-[2rem] shadow-premium border border-white/50 p-8 lg:p-16" data-id="element-244" data-mp="12ym207yn2dy6">
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-24" data-id="element-245" data-mp="17pc7rmaz8ite">
            {/* Мобільний заголовок та бейдж (видно тільки на мобільному) */}
            <div className="lg:hidden flex flex-col items-center text-center gap-4 mb-4" data-id="element-246" data-mp="a7kjpxzng2af">
              <div className="inline-flex items-center justify-center gap-2 px-4 py-1.5 rounded-full border border-brand-primary/10 bg-brand-bg" data-id="element-247" data-mp="f6x66hmlz7ch">
                <ShieldCheck className="w-4 h-4 text-brand-accent" data-id="element-248" data-mp="3707p5jn9vip" />
                <span className="font-medium text-xs uppercase tracking-widest text-brand-primary" data-id="element-249" data-mp="34nroxxg5v8a">
                  В наявності
                </span>
              </div>
              <h1 className="text-4xl font-serif font-medium text-brand-primary leading-tight tracking-tight" data-id="element-250" data-mp="bzbv0ijgp2ug">
                {product.title}
              </h1>
            </div>

            {/* Ліва частина: Фото */}
            <div className="w-full lg:w-1/2 flex-shrink-0" data-id="element-251" data-mp="3gf3besnphsyc">
              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.8,
              ease: [0.23, 1, 0.32, 1]
            }} className="relative w-full rounded-[2rem] overflow-hidden border border-white/40 bg-brand-bg aspect-[4/5] shadow-subtle" data-id="element-252" data-mp="3udt4lx7en8hf">
                <img src={product.img} alt={product.title} className="absolute inset-0 w-full h-full object-cover" data-id="element-253" data-mp="2rlqoa4fzv2uz" />
              </motion.div>
            </div>

            {/* Права частина: Інформація */}
            <div className="w-full lg:w-1/2 flex flex-col text-center lg:text-left" data-id="element-254" data-mp="36a4p69tuoh8w">
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.8,
              delay: 0.2,
              ease: [0.23, 1, 0.32, 1]
            }} className="flex flex-col h-full" data-id="element-255" data-mp="3ab6u97ag7nis">
                {/* Десктопний заголовок та бейдж (сховано на мобільному) */}
                <div className="hidden lg:flex flex-col gap-6 mb-8" data-id="element-256" data-mp="25dmlfm6puh89">
                  <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-brand-primary/10 bg-brand-bg w-fit" data-id="element-257" data-mp="20d8l6qbcwbks">
                    <ShieldCheck className="w-4 h-4 text-brand-accent" data-id="element-258" data-mp="1wcf0s6x4hewn" />
                    <span className="font-medium text-xs uppercase tracking-widest text-brand-primary" data-id="element-259" data-mp="1re3pdrr6iwcb">
                      В наявності
                    </span>
                  </div>
                  <h1 className="text-5xl lg:text-6xl font-serif font-medium text-brand-primary leading-tight tracking-tight" data-id="element-260" data-mp="2k1hgvac3yzp1">
                    {product.title}
                  </h1>
                </div>

                <p className="text-xl text-brand-text mb-12 leading-relaxed font-light" data-id="element-261" data-mp="2aav73wr2p3e9">
                  {product.fullDesc}
                </p>

                <div className="space-y-8 mb-14 text-left" data-id="element-262" data-mp="37t4zz634p6gr">
                  <h3 className="font-serif font-medium text-brand-primary text-2xl mb-6 text-center lg:text-left" data-id="element-263" data-mp="32ztq0w30s9km">
                    Що ви отримуєте:
                  </h3>
                  <div className="flex items-start gap-5" data-id="element-264" data-mp="3fa1hnug2rgfk">
                    <div className="w-8 h-8 rounded-full bg-brand-accent/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-265" data-mp="3fco1asg8pme5">
                      <CheckCircle2 className="w-5 h-5 text-brand-accent" data-id="element-266" data-mp="3oc110tekawlo" />
                    </div>
                    <div data-id="element-267" data-mp="3tb47mia6xavr">
                      <span className="font-serif font-medium text-brand-primary block text-lg mb-1" data-id="element-268" data-mp="3t9t48jknq556">
                        Повністю магнітна основа
                      </span>
                      <span className="text-brand-text text-base leading-relaxed font-light" data-id="element-269" data-mp="6urkn0r1l1en">
                        Надійно тримається на холодильнику, не сповзає.
                      </span>
                    </div>
                  </div>
                  <div className="flex items-start gap-5" data-id="element-270" data-mp="ftmq2am9i7gw">
                    <div className="w-8 h-8 rounded-full bg-brand-accent/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-271" data-mp="kvu89hxoqjro">
                      <CheckCircle2 className="w-5 h-5 text-brand-accent" data-id="element-272" data-mp="2gy70zdvwim77" />
                    </div>
                    <div data-id="element-273" data-mp="2cy6npwkjgh1q">
                      <span className="font-serif font-medium text-brand-primary block text-lg mb-1" data-id="element-274" data-mp="2qnqmysewuw6a">
                        Маркер з губкою в комплекті
                      </span>
                      <span className="text-brand-text text-base leading-relaxed font-light" data-id="element-275" data-mp="2luxkkb6wzzxd">
                        Легко пише та стирається без слідів.
                      </span>
                    </div>
                  </div>
                  <div className="flex items-start gap-5" data-id="element-276" data-mp="39n4l7mjoat2l">
                    <div className="w-8 h-8 rounded-full bg-brand-accent/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-277" data-mp="39kichjl1q7is">
                      <CheckCircle2 className="w-5 h-5 text-brand-accent" data-id="element-278" data-mp="1f8bo1j355u8j" />
                    </div>
                    <div data-id="element-279" data-mp="1a9qrbtn3lsou">
                      <span className="font-serif font-medium text-brand-primary block text-lg mb-1" data-id="element-280" data-mp="1aajyuwtvsm81">
                        Багаторазове використання
                      </span>
                      <span className="text-brand-text text-base leading-relaxed font-light" data-id="element-281" data-mp="3qwgn7eve23pg">
                        Пишіть, стирайте та плануйте знову і знову.
                      </span>
                    </div>
                  </div>
                </div>

                <div className="mt-auto pt-10 border-t border-brand-primary/10 flex flex-col sm:flex-row items-center justify-between gap-8" data-id="element-282" data-mp="3h3rbcivxentl">
                  <div className="text-center sm:text-left w-full sm:w-auto" data-id="element-283" data-mp="385pe8efbcfbl">
                    <p className="text-xs text-brand-muted font-medium uppercase tracking-widest mb-2" data-id="element-284" data-mp="2u5xv5z9xw8qq">
                      Інвестиція в спокій
                    </p>
                    <div className="text-4xl font-serif font-medium text-brand-primary" data-id="element-285" data-mp="2y9cd4vhfuz6t">
                      {product.price}{' '}
                      <span className="text-xl font-sans font-light text-brand-muted" data-id="element-286" data-mp="wgeozcylwus7">грн</span>
                    </div>
                  </div>
                  <button onClick={() => addItem(product)} className="w-full sm:w-auto px-10 py-4 bg-brand-accent hover:bg-brand-accentHover text-white rounded-full font-medium transition-all shadow-button flex items-center justify-center gap-3 group" data-id="element-287" data-mp="3gbe4upwmkois">
                    Замовити зараз
                    <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-288" data-mp="2xl66sm7s8o9g" />
                  </button>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-brand-primary text-brand-bg py-16 mt-24" data-id="element-289" data-mp="2nnry58s3p3rp">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-290" data-mp="2ip8drct5o01g">
          <div className="text-2xl font-serif font-medium tracking-tight" data-id="element-291" data-mp="lvd9lqv1x12b">
            MyPlaner<span className="text-brand-accent" data-id="element-292" data-mp="gxvccxqecaa5">.</span>
          </div>
          <div className="text-brand-bg/40 text-sm font-light" data-id="element-293" data-mp="pe2kac3c5o34">
            © {new Date().getFullYear()} MyPlaner. Всі права захищені.
          </div>
        </div>
      </footer>
    </div>;
}